import Vue from 'vue'
import Vuex from 'vuex'
import {WishListHttpClient} from "../http-clients/WishListHttpClient";
import {CartHttpClient} from "../http-clients/CartHttpClient";
import {AdditionalProductsClient} from "../http-clients/AdditionalProductsClient";

Vue.use(Vuex);
const debug = process.env.NODE_ENV !== 'production';

const wishListModule = {
    namespaced: true,
    state: {
        products: [],
        loading: false,
    },
    actions: {
        async fetchData({ commit }) {
            commit('setLoading', true);

            const httpClient = new WishListHttpClient();
            const data = await httpClient.getData();

            commit('setProducts', data.products);
            commit('setLoading', false);
        },

        async addProductById({commit}, productId) {
            const httpClient = new WishListHttpClient();
            const {
                product,
            } = await httpClient.addProduct(productId);

            commit('addProduct', product);
        },

        async removeProductById({commit}, productId) {
            const httpClient = new WishListHttpClient();
            await httpClient.removeProduct(productId);

            commit('removeProductById', productId);
        }
    },
    mutations: {
        setProducts(state, products) {
            state.products = products;
        },

        addProduct(state, productModel) {
            state.products.push(productModel);
        },

        removeProductById(state, productId) {
            state.products = state.products.filter(product => product.id !== productId);
        },

        setLoading(state, loading) {
            state.loading = loading;
        },
    },
    getters: {
        products: state => state.products,
        loading: state => state.loading,
    }
};

const cartModule = {
    namespaced: true,
    state: {
        items: [],
        shippingDate: null,
        totalPrice: null,
        result: null,
        miniRecommended: null,
        loading: false,
    },
    actions: {
        async fetchData({ commit }) {
            commit('setLoading', true);

            const httpClient = new CartHttpClient();
            const cartData = await httpClient.getData();

            commit('setCartData', cartData);
            commit('setLoading', false);
        },

        async removeItem({commit}, item) {
            const httpClient = new CartHttpClient();
            const { shippingDate, totalPrice, miniRecommended } = await httpClient.removeItemByIndex(item.index);

            commit('removeItem', item);
            commit('setTotalPrice', totalPrice);
            commit('setShippingDate', shippingDate);
            commit('setMiniRecommended', miniRecommended);
        },

        async changeQuantity({commit}, item) {
            const httpClient = new CartHttpClient();
            const cartData = await httpClient.changeQuantity(item.index,item.quantity);

            commit('setCartData', cartData);
            commit('setResult', cartData.result);
        },
    },
    mutations: {
        removeItem(state, itemToRemove) {
            state.items = state.items.filter(item => item !== itemToRemove);
        },

        setCartData(state, cartData) {
            state.items = cartData.items || [];
            state.totalPrice = cartData.totalPrice || 0;
            state.shippingDate = cartData.shippingDate || '';
            state.result = cartData.result || '';
            state.miniRecommended = cartData.miniRecommended || [];
        },

        setTotalPrice(state, totalPrice) {
            state.totalPrice = totalPrice;
        },

        setResult(state, result) {
            state.result = result;
        },

        setShippingDate(state, shippingDate) {
            state.shippingDate = shippingDate;
        },

        setMiniRecommended(state, miniRecommended) {
            state.miniRecommended = miniRecommended;
        },

        setItems(state, items) {
            state.items = items;
        },

        setLoading(state, loading) {
            state.loading = loading;
        }
    },
    getters: {
        cartData: state => state,
        cartProductsCount: state => state.items.length,
        result: state => state.result,
    }
};

const additionalProductsModule = {
    namespaced: true,
    state: {
        categories: [],
        products: [],
        loading: [],
    },
    actions: {
        async fetchData({ commit }) {
            commit('setLoading', true);

            const httpClient = new AdditionalProductsClient();
            const data = await httpClient.getData();

            commit('setCategories', data);
            commit('setProducts', data);
            commit('setLoading', false);
        },
    },
    mutations: {
        setCategories(state, data) {
            state.categories = data.categories || [];
        },

        setProducts(state, data) {
            state.products = data.products || [];
        },

        setLoading(state, loading) {
            state.loading = loading;
        }
    },
    getters: {
        categories: state => state.categories,
        products: state => state.products,
    }
};

export default new Vuex.Store({
    debug,
    modules: {
        cart: cartModule,
        wishList: wishListModule,
        additionalProducts: additionalProductsModule,
    }
})
